export class MediaQueryController {
    constructor(host, query) {
        this.handleMatchesChange = (event) => {
            this.matches = event.matches;
            this.host.requestUpdate();
        };
        (this.host = host).addController(this);
        this.query = query;
        this.matches = query.matches;
    }
    hostConnected() {
        this.query.addEventListener("change", this.handleMatchesChange);
    }
    hostDisconnected() {
        this.query.removeEventListener("change", this.handleMatchesChange);
    }
}
